import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import beach from "../assets/img/tourdetails-img (1).jpg";
import img2 from "../assets/img/homepage/img3.png";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Traveldetails() {
  useEffect(() => {
    AOS.init({ duration: 1100, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="discover-section py-10 container-fluid">
      <Container>
        <Row className="align-items-center gy-4">
          {/* LEFT CONTENT */}
          <Col md={6} data-aos="fade-right">
            <h3 className="new-font mb-2">Dream Your Next Trip</h3>

            <h2 className="fw-bold mb-3" style={{ color: "#000" }}>
              Discover When Even <br /> You Want To Go
            </h2>

            <p className="text-muted mb-4">
              Are you tired of the typical tourist destinations and looking to
              step out of your comfort zone? Adventure travel may be the perfect
              solution for you! Here are four.
            </p>

            {/* Feature 1 */}
            <div
              className="feature-item d-flex align-items-start mb-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="feature-icon me-3 mt-4">
                <i className="bi bi-geo-alt-fill" />
              </div>
              <div>
                <h6 className="fw-bold mb-1">Best Travel Agency</h6>
                <p className="text-muted mb-0">
                  Are you tired of the typical tourist destination and looking
                  step out of your comfort.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div
              className="feature-item d-flex align-items-start mb-4"
              data-aos="fade-up"
              data-aos-delay="250"
            >
              <div className="feature-icon me-3 mt-4">
                <i className="bi bi-suitcase-fill" />
              </div>
              <div>
                <h6 className="fw-bold mb-1">Secure Journey With Us</h6>
                <p className="text-muted mb-0">
                  Are you tired of the typical tourist destination and looking
                  step out of your comfort.
                </p>
              </div>
            </div>

            {/* Button */}
            <Link
              to="/tour-packages"
              className="take-tour-btn mt-4"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              BOOK YOUR TRIP <i className="bi bi-arrow-right ms-2" />
            </Link>
          </Col>

          {/* RIGHT IMAGES */}
          <Col
            md={6}
            className="text-center position-relative"
            data-aos="zoom-in"
          >
            <div className="image-wrapper position-relative">
              {/* Main Image */}
              <img
                src={beach}
                alt="Beach View"
                className="main-img rounded-4"
              />

              {/* Secondary Image */}
              <img
                src={img2}
                alt="Couple Travel"
                className="sub-img rounded-4"
                data-aos="fade-left"
                data-aos-delay="200"
              />

              {/* Floating Text */}
              <h1
                className="travel-text"
                data-aos="fade-up"
                data-aos-delay="350"
              >
                TRAVEL
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
